import * as THREE from 'three';
import { baseCommand } from './basecommand';

type camerastatustypename = "camera";
type camerastatusdatatype = {
        "translate": number[];
        "rotation": number;
        "elevationAngle": number;
        "fov": number;
        "indoors": boolean;
}

type pscommand<T> = {
    "type": T extends camerastatustypename ? T : never;
    "data": T extends camerastatustypename ? camerastatusdatatype : never;
};

export type cameraStatusCommand = pscommand<camerastatustypename>;

export class cameraStatus extends baseCommand {

    private yup: THREE.Vector3;

    constructor(private camera: THREE.PerspectiveCamera, private indoorMode: boolean) {
        super();
        this.yup = new THREE.Vector3(0, 1, 0);
    }

    public object(): cameraStatusCommand {

        const conv = (n: number) => {
            return     Math.floor(n * 1000) / 1000;
        }

        const position = this.camera.getWorldPosition(new THREE.Vector3());
        return {
            "type": "camera",
            "data": {
                "translate": [conv(position.x), conv(position.y), conv(position.z)],
                "rotation": conv(this.rotaion()),
                "elevationAngle": conv(this.elevatonAngle()),
                "fov": conv(this.camera.fov),
                "indoors": this.indoorMode
            }
        }
    }

    private direction() {
        return this.camera.getWorldDirection(new THREE.Vector3());
    }

    private cameraZ() {
        return this.direction().clone().projectOnPlane(this.yup).normalize();
    }

    private elevatonAngle() {
        // カメラの上下角
        // X-Z平面にカメラの向きベクトルの射影を行い
        // 射影ベクトルとカメラの向きベクトルで角度を測る
        const direction = this.direction();
        let elevationAngle = this.cameraZ().angleTo(direction);
        if (this.yup.dot(direction) < 0) elevationAngle *= -1;
        return elevationAngle;
    }

    private rotaion() {
        // Y軸基準での回転角
        // X-Z平面に射影を行いZ(0,0,1)との角度を測る
        const zvector = new THREE.Vector3(0, 0, 1)
        let angle = zvector.angleTo(this.cameraZ());

        const xVEc = new THREE.Vector3(1, 0, 0);
        if (xVEc.dot(this.cameraZ()) < 0) angle *= -1;
        return angle;
    }

    private console() {
        console.log('position', this.camera.position);
        const direction = new THREE.Vector3();
        this.camera.getWorldDirection(direction)
        console.log('direction', direction);

        // カメラの上下角
        // X-Z平面にカメラの向きベクトルの射影を行い
        // 射影ベクトルとカメラの向きベクトルで角度を測る
        const yup = new THREE.Vector3(0, 1, 0);
        const cameraZ = direction.clone().projectOnPlane(yup).normalize();

        let elevationAngle = cameraZ.angleTo(direction);
        if (yup.dot(direction) < 0) elevationAngle *= -1;

        console.log(elevationAngle * 180 / Math.PI);

        // Y軸基準での回転角
        // X-Z平面に射影を行いZ(0,0,1)との角度を測る
        const zvector = new THREE.Vector3(0, 0, 1);
        let angle = zvector.angleTo(cameraZ);

        if (zvector.dot(cameraZ) < 0) angle *= -1;
        console.log(angle * 180 / Math.PI);

        // console.log(this.jsonString());
        // this.calcVector()
    }

    private calcVector() {
        this.camera.updateMatrixWorld();

        const rotationMatrix = new THREE.Matrix4().extractRotation(this.camera.matrixWorld);
        // rotationMatrix will now contains the rotation component of your object's world matrix

        const worldUp = new THREE.Vector3(0, 1, 0).applyMatrix4(rotationMatrix).normalize();
        const worldLeft = new THREE.Vector3(1, 0, 0).applyMatrix4(rotationMatrix).normalize();
        const worldFront = new THREE.Vector3(0, 0, 1).applyMatrix4(rotationMatrix).normalize();

        const yup = new THREE.Vector3(0, 1, 0);
        const direction = this.camera.getWorldDirection(new THREE.Vector3());
        //XZ平面に対してカメラの左側ベクトル（ワールド）を射影
        const cameraFront = worldFront.clone().projectOnPlane(yup).normalize();
        let FrontAngle = cameraFront.angleTo(worldFront);
        if (yup.dot(worldFront) < 0) FrontAngle *= -1;

        console.log(`仰角: ${FrontAngle * 180 / Math.PI}`);

        const cameraLeft = worldLeft.clone().projectOnPlane(yup).normalize();
        let leftAngle = cameraLeft.angleTo(worldLeft);
        if (yup.dot(worldLeft) < 0) leftAngle *= -1;

        console.log(`左角: ${leftAngle * 180 / Math.PI}`);
    }
}
